export default class Navigation {
  constructor() {
    this.init();
  }

  init() {
    const liElements = document.querySelectorAll('.primary-nav__li.has-children');
    const buttonElements = document.querySelectorAll('.primary-nav__li.has-children button.primary-nav__links');

    liElements.forEach((el) => {
      const pid = el.dataset.pid;
      const buttonEl = el.querySelector('button.primary-nav__links');

      el.addEventListener('mouseenter', () => {
        this.showMenu(buttonEl, pid);
      });

      el.addEventListener('mouseleave', () => {
        this.hideMenu(buttonEl);
      });
    });

    buttonElements.forEach((el) => {
      const pid = el.dataset.pid;
      const url = new URL(el.dataset.url);

      if (window.location.pathname.includes(url.pathname)) {
        el.classList.add('active');
      }

      el.addEventListener('keydown', (e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          this.toggleMenu(el, pid);
        }
      });

      el.addEventListener('keyup', (e) => {
        if (e.key === " ") {
          e.preventDefault();
          this.toggleMenu(el, pid);
        }
      });

      el.addEventListener('click', () => {
        window.location.href = el.dataset.url;
      });
    });

    document.querySelectorAll('.primary-nav a').forEach((el) => {
      const url = new URL(el.getAttribute('href'));
      if (window.location.pathname.includes(url.pathname)) {
        el.classList.add('active');
        el.setAttribute('aria-current', 'page');
      }
    });
  }

  toggleMenu(el, pid) {
    const isOpen = el.getAttribute('aria-expanded');
    if (isOpen == 'false') {
      this.showMenu(el, pid);
    } else {
      this.hideMenu(el);
    }
  }

  hideMenu(buttonEl) {
    buttonEl.setAttribute('aria-expanded', 'false');
    if (this.currentSubmenu) {
      this.currentSubmenu.classList.remove('show');
    }
  }

  showMenu(buttonEl, pid) {
    buttonEl.setAttribute('aria-expanded', 'true');
    this.currentSubmenu = document.getElementById(pid);
    this.currentSubmenu.classList.add('show');

    let activeSubmenu = this.currentSubmenu;

    activeSubmenu.addEventListener('focusout', function (event) {
      if(activeSubmenu.contains(event.relatedTarget)) return;

      buttonEl.setAttribute('aria-expanded', 'false');
      activeSubmenu.classList.remove('show');
    });
  }
}

